<template>
    <div class="My_favourite main-container">
        <p class="title">我的收藏</p>
        <div v-if="Favouritelist.length>0">
          <div v-for="(item,index) in Favouritelist " :key="index">
              <div class="allorder">
              <!-- <input v-show="manage" type="checkbox" class="tui-checkbox" name="test" :value="item.product_id"> -->
              <div class="orderlft" @click="skip(item.product_id)">
                  <div>
                      <img :src="imgsrc + item.cover" alt="">
                  </div>
              </div>
              <div class="orderrig">
                  <p>{{ item.name }}</p>
                  <p>￥{{ (+ item.unit_price).toFixed(2) }}</p>
                  <p>{{item.product_collection_num}}+人收藏 <span @click="delhandl(item.product_id)"><i class="el-icon-error" style="color: red; font-size: 0.24rem"></i>删除</span></p>
              </div>
              </div>
              <div style="height:1px;background: rgba(0, 56, 63, 0.5);margin:0 0.3rem"></div>
          </div>          
        </div>

        <div v-else> <router-link to="/" style="font-size:.3rem;">空空如也，去首页看看 &gt;&gt;</router-link></div>
       
        <!-- <div class="manage" @click="manage = true ">管理</div>
        <p style="margin-bottom:1rem;font-size:0.3rem;font-weight: 900;" @click="dellosthandl">删除</p> -->
    </div>
</template>

<script>
import { collection_list_url,collection_del_url } from '../request/api'
export default {
    name: 'NewLiuyanShopWebMyFavourite',

    data() {
        return {
            Favouritelist:[],
            check_val:[],
            manage:false
        };
    },

    mounted() {
      this.Datalist()
      if (!this.$store.state.isLogin) {
          this.$message.success('跳转登录页');
        this.$router.push({ path: "/Login" });
      }
        
    },

    methods: {
      skip(id){
        this.$router.push({path:'/Product',query:{id:id}})
      },
    dellosthandl(){
             let obj = document.getElementsByName("test");
            for(var i=0; i<obj.length;i++){
                if(obj[i].checked)
                    this.check_val.push(obj[i].value);
            }
            this.delhandl(this.check_val)
    },
    delhandl(id){
        collection_del_url({product_id:id}).then((res)=>{
            console.log(res)
            if(res.data.code == 200){
                this.Datalist()
                this.manage = false
            }
        })
    },

    Datalist(){
           collection_list_url().then((res)=>{
            this.Favouritelist = res.data.data
            console.log(this.Favouritelist)

        })
    }
    },
};
</script>

<style lang="less" scoped>
.My_favourite{
  min-height: 10rem;
    .title{
        padding: 1.07rem 0 0.7rem 0;
        font-size: 0.4rem;
        font-weight: 900;
    }
       input[type="checkbox"]{width:0.41rem;height:0.4rem;display: inline-block;text-align: center;vertical-align: middle; line-height: 18px;position: relative;margin: 0.88rem 0.25rem 0rem 0}
              input[type="checkbox"]::before{content: "";position: absolute;top: 0;left: 0;background: #fff;width: 0.4rem;height: 0.4rem;border: 1px solid #00383F}
              input[type="checkbox"]:checked::before{content: '';width: 0.4rem;height: 0.4rem;background:#fff url("../../static/mobile/duihao.png") no-repeat;background-size: 0.4rem 0.4rem;}
   .allorder{
    overflow: hidden;
    padding: 0.6rem 0.8rem 0.6rem 0.3rem;
    //  padding: 0 0.8rem;
    display: flex;
    
    .orderlft{
      width:23%;
      float: left;
      div{  
        width: 1.367rem;
        height: 2rem;
        background: url(../../static/mobile/product.png) no-repeat;
        background-size: 100% 100%;
        border: 1px solid #00383F ;
          img{
          width: 100%;
          padding-top: 0.27rem;
        }
      }
      span{
        display: inline-block;
        width: 100%;
        font-size: 0.19rem;
        text-align: left;
        margin-top: 0.3rem;
      }
    }
    .orderrig{
      width: 70%;
      float: left;
      text-align: left;
      margin-left: 7%;
      p{
        font-size: 0.24rem;
        font-weight: bold;
        color: #00383F;
        span{
            float: right;
            i{
                display: inline-block;
                margin-right: 0.1rem;
            }
        }
      }
      p:nth-child(1){
        font-size: 0.3rem;
        padding-top: 0.19rem;
      }
        p:nth-child(2){
          padding: 0.32rem 0 0.3rem 0;
      }
      .btnbox{
        overflow: hidden;
        margin-top: 0.68rem;
        div{
          width: 1.2rem;
          height: 0.4rem;
          background: #00383F;
          color: #fff;
          text-align: center;
          line-height: 0.4rem;
          float: right;
          font-size: 0.22rem;
        }
        div:nth-child(2){
          margin-right: 0.3rem;
        }
      }
    }
  }
  .manage{
      margin: 2rem 0.3rem 0.49rem 0.3rem;
      height: 0.9rem;
      font-size: 0.36rem;
      color: #fff;
      line-height: 0.9rem;
      background: #00383F;
      margin-top: 2rem;
      margin-bottom: 0.49rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/collection.vue